var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paragraph-title my-2"},[_c('global-rich-text',{attrs:{"payload":_vm.paragraph}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }